import { Link as RouterLink } from "react-router";
import { styled } from "styled-components";

import { UIChip } from "common/components";
import { linkStyles } from "common/styles";
import { useTranslate } from "common/utilities/useTranslate";
import type { ParentTopic } from "entities/topics/types";

type TopicDetailParentTopicProps = { parent_topic: ParentTopic };

export const TopicDetailParentTopic = ({ parent_topic }: TopicDetailParentTopicProps) => {
  const translate = useTranslate();

  return (
    <>
      <Subtitle>{translate("app.topic.parent_insight_area_title")}</Subtitle>
      <Link data-test-id="go-to-parent-topic-link" to={`/topics/${parent_topic.id}`}>
        <UIChip>{parent_topic.name}</UIChip>
      </Link>
    </>
  );
};

const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.fillPrimary};
  font-size: 1rem;
  font-weight: bold;
  line-height: 19px;
  margin: 0.6rem 0 0.4rem 0;
`;

const Link = styled(RouterLink)`
  ${linkStyles}
`;
